import * as React from 'react';
import { RuleCode, RuleField } from 'typings/enums';
import { IWorkflowRule } from 'typings/workflowRule';
import { WorkflowConfiguration } from 'nomst/Stores/Configuration/workflowConfiguration';
import './workflowRule.scss';

export interface IWorkflowRuleProps {
    rule: IWorkflowRule;
    workflowConfiguration: WorkflowConfiguration;
    readonly?: boolean;
}

export default class WorkflowRule extends React.PureComponent<IWorkflowRuleProps> {
    constructor(props: IWorkflowRuleProps) {
        super(props);
        this.handleDeleteRule = this.handleDeleteRule.bind(this);
    }

    render(): React.ReactNode {
        const { rule, readonly } = this.props;
        const boxClasses = rule.code === RuleCode.FollowHierarchy ? 'pxl-box follow-hierarchy' : 'pxl-box';
        return (
            <div className="nomst-workflow-rule pxl-box-wrapper">
                <div className={boxClasses}>
                    <i className="icon-sitemap" />
                    {this.getRuleTitle(rule)}
                    <button
                        className="nomst-workflow-rule__delete-btn pxl-btn icon-btn"
                        disabled={readonly}
                        onClick={this.handleDeleteRule}
                    >
                        <i className="icon-cancel" />
                    </button>
                </div>
            </div>
        );
    }

    private getRuleTitle(rule: IWorkflowRule): string {
        switch (rule.code) {
            case RuleCode.FollowHierarchy:
                switch (rule.field) {
                    case RuleField.BusinessUnit: return 'Follow Hierarchy to Business Unit';
                    case RuleField.Department: return 'Follow Hierarchy to Department';
                    case RuleField.Division: return 'Follow Hierarchy to Division';
                    case RuleField.LevelBelowCeo: return 'Follow Hierarchy to Level below CEO';
                    default: return 'Follow Hierarchy to CEO';
                }
            case RuleCode.GoToFieldLeader:
                switch (rule.field) {
                    case RuleField.BusinessUnit: return 'Head of Business Unit';
                    case RuleField.Department: return 'Head of Department';
                    case RuleField.Division: return 'Head of Division';
                    default: return 'CEO';
                }
            case RuleCode.HumanResourceApprover: return 'HR Administrator';
            case RuleCode.HumanResourceReviewer:
                switch (rule.field) {
                    case RuleField.BusinessUnit: return 'HR Business Unit Business Partner';
                    case RuleField.Department: return 'HR Department Business Partner';
                    case RuleField.Division: return 'HR Division Business Partner';
                    default: return 'HR Business Partner';
                }
            case RuleCode.ImmediateManager: return 'Direct Manager';
        }
    }

    private handleDeleteRule(): void {
        const { rule, workflowConfiguration } = this.props;
        workflowConfiguration.deleteRule(rule);
    }
}